import {HK_PACK_SHIP_START} from '../../common/constants/HotKeys.js'
import ButtonPrimary from '../../common/components/Button/ButtonPrimary.js'
import LinkButton from '../../common/components/Link/LinkButton.js'
import {
  packShipOrderNumbersSelector,
  indexSelector,
  navigateToPackShip,
} from './packShipFunctions.js'
import {AWAITING_FULFILLMENT} from '../../common/constants/Orders.js'
import {orderListHashBuilder} from '../OrderListPage/orderListSelectors.js'
import {useSelector} from '../../store.js'

export default function DonePanel() {
  const orderNumbers = useSelector(packShipOrderNumbersSelector)
  const index = useSelector(indexSelector)

  if (orderNumbers.length === 1 || index === orderNumbers.length - 1) {
    return (
      <div className="flex--justify-col">
        <ButtonPrimary
          className="btn--sm"
          isOutlined
          onClick={() => navigateToPackShip()}
          hotKey={HK_PACK_SHIP_START}
        >
          Verify Another Order
        </ButtonPrimary>
      </div>
    )
  }

  if (index < orderNumbers.length - 1) {
    return (
      <div className="flex--justify-col">
        <LinkButton
          href={orderListHashBuilder({status: [AWAITING_FULFILLMENT]})}
          mode="primary"
          className="btn--primary-ol btn--sm"
        >
          Start Over
        </LinkButton>
      </div>
    )
  }

  return null
}
